/* Neue Zeile bei der Verwendung von display:flex mit flexWrap: 'wrap'*/

type Param = {
    className?: string
}

const FlexNewLine: React.FC<Param> = ({ className }) => {
    return <div className={className} style={{ flexBasis: '100%', height: 0 }} />
}

export default FlexNewLine;